import { render, staticRenderFns } from "./MRegisterPassEditComp.vue?vue&type=template&id=607b0ac8&scoped=true&"
import script from "./MRegisterPassEditComp.vue?vue&type=script&lang=ts&"
export * from "./MRegisterPassEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./MRegisterPassEditComp.vue?vue&type=style&index=0&id=607b0ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607b0ac8",
  null
  
)

export default component.exports